import { useState, useEffect, useRef } from 'react';
import { ChevronDown } from 'lucide-react';

const COUNTRIES = [
  // Priority
  { code: 'HT', name: 'Haiti',                    dial: '+509',  flag: '🇭🇹', placeholder: 'XX XX XXXX' },
  { code: 'US', name: 'United States',             dial: '+1',    flag: '🇺🇸', placeholder: '(000) 000-0000' },
  { code: 'CA', name: 'Canada',                    dial: '+1',    flag: '🇨🇦', placeholder: '(000) 000-0000' },
  { code: 'FR', name: 'France',                    dial: '+33',   flag: '🇫🇷', placeholder: '0 00 00 00 00' },
  // Caribbean
  { code: 'AG', name: 'Antigua & Barbuda',         dial: '+1268', flag: '🇦🇬', placeholder: '000-0000' },
  { code: 'AW', name: 'Aruba',                     dial: '+297',  flag: '🇦🇼', placeholder: '000 0000' },
  { code: 'BB', name: 'Barbados',                  dial: '+1246', flag: '🇧🇧', placeholder: '000-0000' },
  { code: 'BS', name: 'Bahamas',                   dial: '+1242', flag: '🇧🇸', placeholder: '000-0000' },
  { code: 'BQ', name: 'Bonaire',                   dial: '+599',  flag: '🇧🇶', placeholder: '000 0000' },
  { code: 'BZ', name: 'Belize',                    dial: '+501',  flag: '🇧🇿', placeholder: '000-0000' },
  { code: 'CU', name: 'Cuba',                      dial: '+53',   flag: '🇨🇺', placeholder: '0 000 0000' },
  { code: 'CW', name: 'Curaçao',                   dial: '+599',  flag: '🇨🇼', placeholder: '0 000 0000' },
  { code: 'DM', name: 'Dominica',                  dial: '+1767', flag: '🇩🇲', placeholder: '000-0000' },
  { code: 'DO', name: 'Dominican Republic',        dial: '+1809', flag: '🇩🇴', placeholder: '000-0000' },
  { code: 'GD', name: 'Grenada',                   dial: '+1473', flag: '🇬🇩', placeholder: '000-0000' },
  { code: 'GP', name: 'Guadeloupe',                dial: '+590',  flag: '🇬🇵', placeholder: '000 00 00 00' },
  { code: 'GY', name: 'Guyana',                    dial: '+592',  flag: '🇬🇾', placeholder: '000 0000' },
  { code: 'JM', name: 'Jamaica',                   dial: '+1876', flag: '🇯🇲', placeholder: '000-0000' },
  { code: 'KN', name: 'St Kitts & Nevis',          dial: '+1869', flag: '🇰🇳', placeholder: '000-0000' },
  { code: 'KY', name: 'Cayman Islands',            dial: '+1345', flag: '🇰🇾', placeholder: '000-0000' },
  { code: 'LC', name: 'Saint Lucia',               dial: '+1758', flag: '🇱🇨', placeholder: '000-0000' },
  { code: 'MQ', name: 'Martinique',                dial: '+596',  flag: '🇲🇶', placeholder: '000 00 00 00' },
  { code: 'MS', name: 'Montserrat',                dial: '+1664', flag: '🇲🇸', placeholder: '000-0000' },
  { code: 'PR', name: 'Puerto Rico',               dial: '+1939', flag: '🇵🇷', placeholder: '000-0000' },
  { code: 'SR', name: 'Suriname',                  dial: '+597',  flag: '🇸🇷', placeholder: '000-0000' },
  { code: 'SX', name: 'Sint Maarten',              dial: '+1721', flag: '🇸🇽', placeholder: '000-0000' },
  { code: 'TC', name: 'Turks & Caicos',            dial: '+1649', flag: '🇹🇨', placeholder: '000-0000' },
  { code: 'TT', name: 'Trinidad & Tobago',         dial: '+1868', flag: '🇹🇹', placeholder: '000-0000' },
  { code: 'VC', name: 'St Vincent & Grenadines',   dial: '+1784', flag: '🇻🇨', placeholder: '000-0000' },
  { code: 'VG', name: 'British Virgin Islands',    dial: '+1284', flag: '🇻🇬', placeholder: '000-0000' },
  { code: 'VI', name: 'US Virgin Islands',         dial: '+1340', flag: '🇻🇮', placeholder: '000-0000' },
  // Latin America
  { code: 'AR', name: 'Argentina',                 dial: '+54',   flag: '🇦🇷', placeholder: '00 0000-0000' },
  { code: 'BO', name: 'Bolivia',                   dial: '+591',  flag: '🇧🇴', placeholder: '0 000 0000' },
  { code: 'BR', name: 'Brazil',                    dial: '+55',   flag: '🇧🇷', placeholder: '(00) 00000-0000' },
  { code: 'CL', name: 'Chile',                     dial: '+56',   flag: '🇨🇱', placeholder: '0 0000 0000' },
  { code: 'CO', name: 'Colombia',                  dial: '+57',   flag: '🇨🇴', placeholder: '000 000 0000' },
  { code: 'CR', name: 'Costa Rica',                dial: '+506',  flag: '🇨🇷', placeholder: '0000 0000' },
  { code: 'EC', name: 'Ecuador',                   dial: '+593',  flag: '🇪🇨', placeholder: '00 000 0000' },
  { code: 'GT', name: 'Guatemala',                 dial: '+502',  flag: '🇬🇹', placeholder: '0000 0000' },
  { code: 'HN', name: 'Honduras',                  dial: '+504',  flag: '🇭🇳', placeholder: '0000-0000' },
  { code: 'MX', name: 'Mexico',                    dial: '+52',   flag: '🇲🇽', placeholder: '00 0000 0000' },
  { code: 'NI', name: 'Nicaragua',                 dial: '+505',  flag: '🇳🇮', placeholder: '0000 0000' },
  { code: 'PA', name: 'Panama',                    dial: '+507',  flag: '🇵🇦', placeholder: '000 0000' },
  { code: 'PE', name: 'Peru',                      dial: '+51',   flag: '🇵🇪', placeholder: '000 000 000' },
  { code: 'PY', name: 'Paraguay',                  dial: '+595',  flag: '🇵🇾', placeholder: '000 000 000' },
  { code: 'SV', name: 'El Salvador',               dial: '+503',  flag: '🇸🇻', placeholder: '0000 0000' },
  { code: 'UY', name: 'Uruguay',                   dial: '+598',  flag: '🇺🇾', placeholder: '00 000 000' },
  { code: 'VE', name: 'Venezuela',                 dial: '+58',   flag: '🇻🇪', placeholder: '000 000 0000' },
  // Popular global
  { code: 'AU', name: 'Australia',                 dial: '+61',   flag: '🇦🇺', placeholder: '000 000 000' },
  { code: 'BE', name: 'Belgium',                   dial: '+32',   flag: '🇧🇪', placeholder: '000 00 00 00' },
  { code: 'CH', name: 'Switzerland',               dial: '+41',   flag: '🇨🇭', placeholder: '00 000 00 00' },
  { code: 'CN', name: 'China',                     dial: '+86',   flag: '🇨🇳', placeholder: '000 0000 0000' },
  { code: 'DE', name: 'Germany',                   dial: '+49',   flag: '🇩🇪', placeholder: '000 00000000' },
  { code: 'ES', name: 'Spain',                     dial: '+34',   flag: '🇪🇸', placeholder: '000 000 000' },
  { code: 'GB', name: 'United Kingdom',            dial: '+44',   flag: '🇬🇧', placeholder: '0000 000000' },
  { code: 'GH', name: 'Ghana',                     dial: '+233',  flag: '🇬🇭', placeholder: '000 000 0000' },
  { code: 'IN', name: 'India',                     dial: '+91',   flag: '🇮🇳', placeholder: '00000 00000' },
  { code: 'IT', name: 'Italy',                     dial: '+39',   flag: '🇮🇹', placeholder: '000 000 0000' },
  { code: 'JP', name: 'Japan',                     dial: '+81',   flag: '🇯🇵', placeholder: '00 0000 0000' },
  { code: 'MA', name: 'Morocco',                   dial: '+212',  flag: '🇲🇦', placeholder: '000-000000' },
  { code: 'NG', name: 'Nigeria',                   dial: '+234',  flag: '🇳🇬', placeholder: '000 000 0000' },
  { code: 'NL', name: 'Netherlands',               dial: '+31',   flag: '🇳🇱', placeholder: '00 0000 0000' },
  { code: 'NZ', name: 'New Zealand',               dial: '+64',   flag: '🇳🇿', placeholder: '00 000 0000' },
  { code: 'PT', name: 'Portugal',                  dial: '+351',  flag: '🇵🇹', placeholder: '000 000 000' },
  { code: 'SN', name: 'Senegal',                   dial: '+221',  flag: '🇸🇳', placeholder: '00 000 00 00' },
  { code: 'ZA', name: 'South Africa',              dial: '+27',   flag: '🇿🇦', placeholder: '00 000 0000' },
];

export default function PhoneInput({ onChange }) {
  const [country, setCountry] = useState(COUNTRIES[0]); // default HT
  const [number, setNumber] = useState('');
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);
  const inputRef = useRef(null);
  const searchRef = useRef(null);
  const [search, setSearch] = useState('');

  // Auto-detect country via IP
  useEffect(() => {
    let cancelled = false;
    fetch('https://ipapi.co/json/')
      .then((r) => r.json())
      .then((data) => {
        if (cancelled) return;
        const detected = COUNTRIES.find((c) => c.code === data.country_code);
        if (detected) setCountry(detected);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  // Close dropdown on outside click
  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
        setSearch('');
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  // Focus search input when dropdown opens
  useEffect(() => {
    if (open && searchRef.current) {
      setTimeout(() => searchRef.current?.focus(), 30);
    }
  }, [open]);

  const filteredCountries = search.trim()
    ? COUNTRIES.filter(
        (c) =>
          c.name.toLowerCase().includes(search.toLowerCase()) ||
          c.code.toLowerCase().includes(search.toLowerCase()) ||
          c.dial.includes(search)
      )
    : COUNTRIES;

  const handleNumberChange = (e) => {
    const raw = e.target.value.replace(/[^\d\s\-()]/g, '');
    setNumber(raw);
    const digits = raw.replace(/\D/g, '');
    onChange(digits ? `${country.dial}${digits}` : '');
  };

  const handleCountrySelect = (c) => {
    setCountry(c);
    setOpen(false);
    setSearch('');
    const digits = number.replace(/\D/g, '');
    onChange(digits ? `${c.dial}${digits}` : '');
    setTimeout(() => inputRef.current?.focus(), 30);
  };

  const toggleOpen = () => {
    setOpen((v) => !v);
    if (open) setSearch('');
  };

  return (
    <div className="relative" ref={wrapperRef}>
      {/* Compound input row */}
      <div className="flex rounded-[8px] border border-[#DDEBFA] bg-white/80 focus-within:border-[#1E4FA1] focus-within:ring-1 focus-within:ring-[#1E4FA1]/20 transition-all overflow-hidden h-12">
        {/* Country selector button */}
        <button
          type="button"
          onClick={toggleOpen}
          aria-haspopup="listbox"
          aria-expanded={open}
          aria-label="Select country code"
          className="flex items-center gap-1 sm:gap-1.5 px-2.5 sm:px-3 shrink-0 bg-transparent hover:bg-[#F8FBFF] focus:outline-none transition-colors border-r border-[#DDEBFA]"
          style={{ minWidth: '4.5rem' }}
        >
          <span className="text-lg leading-none select-none">{country.flag}</span>
          <span className="text-xs font-medium text-[#0F172A]">{country.dial}</span>
          <ChevronDown
            size={12}
            className={`text-[#94A3B8] transition-transform duration-200 shrink-0 ${open ? 'rotate-180' : ''}`}
          />
        </button>

        {/* Phone number input */}
        <input
          ref={inputRef}
          type="tel"
          value={number}
          onChange={handleNumberChange}
          placeholder={country.placeholder}
          maxLength={20}
          className="flex-1 min-w-0 px-3 bg-transparent text-sm text-[#0F172A] placeholder:text-[#94A3B8] focus:outline-none"
        />
      </div>

      {/* Dropdown */}
      {open && (
        <div
          role="listbox"
          aria-label="Select country"
          className="absolute top-full left-0 z-50 mt-1.5 w-72 rounded-[8px] border border-[#DDEBFA] bg-white shadow-[0_8px_24px_rgba(11,31,77,0.12)] overflow-hidden"
        >
          {/* Search */}
          <div className="p-2 border-b border-[#F1F5F9]">
            <input
              ref={searchRef}
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search country…"
              className="w-full px-3 py-1.5 text-sm rounded-[6px] border border-[#DDEBFA] bg-[#F8FBFF] text-[#0F172A] placeholder:text-[#94A3B8] focus:outline-none focus:border-[#1E4FA1]"
            />
          </div>

          {/* Country list */}
          <ul className="max-h-60 overflow-y-auto overscroll-contain">
            {filteredCountries.length === 0 ? (
              <li className="px-4 py-3 text-sm text-[#94A3B8] text-center">No results</li>
            ) : (
              filteredCountries.map((c) => {
                const isSelected = c.code === country.code && c.dial === country.dial;
                return (
                  <li key={`${c.code}-${c.dial}`}>
                    <button
                      type="button"
                      role="option"
                      aria-selected={isSelected}
                      onClick={() => handleCountrySelect(c)}
                      className={`w-full flex items-center gap-3 px-4 py-2.5 text-sm text-left transition-colors ${
                        isSelected
                          ? 'bg-[#EAF4FF] text-[#1E4FA1] font-semibold'
                          : 'text-[#0F172A] hover:bg-[#F0F6FF]'
                      }`}
                    >
                      <span className="text-base leading-none select-none">{c.flag}</span>
                      <span className="font-medium w-7 shrink-0">{c.code}</span>
                      <span className="flex-1 truncate text-[#475569] font-normal">{c.name}</span>
                      <span className="font-mono text-[11px] text-[#94A3B8] shrink-0">{c.dial}</span>
                    </button>
                  </li>
                );
              })
            )}
          </ul>
        </div>
      )}
    </div>
  );
}
